import {
  POPUP_AGE_APPROVAL,
  POPUP_AGE_VERIFICATION_SUCCESS,
  POPUP_BUY_SUBSCRIPTION,
  POPUP_CAMERA_FEEDBACK,
  POPUP_CHANGE_AVATAR,
  POPUP_COINSCHARGE,
  POPUP_COINSCHARGE_SUCCESS,
  POPUP_COOKIES,
  POPUP_DISCOUNT,
  POPUP_DOUBLE_OPT_IN,
  POPUP_DOUBLE_OPT_IN_FINISH,
  POPUP_FEATURE_FEEDBACK,
  POPUP_FEATURE_INTRODUCE,
  POPUP_FEEDBACK,
  POPUP_FEEDBACK_REMOVAL,
  POPUP_FEEDBACK_SUCCESS,
  POPUP_FREECHAT,
  POPUP_LAW_LIMITATION,
  POPUP_MANUAL_CANCELLATION,
  POPUP_MODEL_TIP,
  POPUP_MODEL_TIP_OFFER,
  POPUP_MODEL_TIP_SUCCESS,
  POPUP_ORGANIC,
  POPUP_PLAYDATE_FEEDBACK,
  POPUP_PLAYDATE_FORBIDDANCE,
  POPUP_PLAYDATE_REQUEST_SUCCESS,
  POPUP_TRANSACTIONAL,
} from "@/utils/variables";

interface PopupConfig {
  requiresAuth: boolean;
  initOnHash: boolean;
}

const config: Record<string, PopupConfig> = {};
config[POPUP_DOUBLE_OPT_IN] = { requiresAuth: true, initOnHash: false };
config[POPUP_DOUBLE_OPT_IN_FINISH] = { requiresAuth: true, initOnHash: false };
config[POPUP_BUY_SUBSCRIPTION] = { requiresAuth: true, initOnHash: true };
config[POPUP_FEEDBACK] = { requiresAuth: true, initOnHash: false };
config[POPUP_FEEDBACK_SUCCESS] = { requiresAuth: true, initOnHash: false };
config[POPUP_FEEDBACK_REMOVAL] = { requiresAuth: true, initOnHash: false };
config[POPUP_COINSCHARGE] = { requiresAuth: true, initOnHash: true };
config[POPUP_COINSCHARGE_SUCCESS] = { requiresAuth: true, initOnHash: false };
config[POPUP_AGE_VERIFICATION_SUCCESS] = { requiresAuth: true, initOnHash: false };
config[POPUP_PLAYDATE_FEEDBACK] = { requiresAuth: true, initOnHash: false };
config[POPUP_PLAYDATE_FORBIDDANCE] = { requiresAuth: true, initOnHash: false };
config[POPUP_PLAYDATE_REQUEST_SUCCESS] = { requiresAuth: true, initOnHash: false };
config[POPUP_TRANSACTIONAL] = { requiresAuth: true, initOnHash: false };
config[POPUP_FREECHAT] = { requiresAuth: true, initOnHash: false };
config[POPUP_COOKIES] = { requiresAuth: false, initOnHash: false };
config[POPUP_AGE_APPROVAL] = { requiresAuth: false, initOnHash: false };
config[POPUP_ORGANIC] = { requiresAuth: true, initOnHash: false };
config[POPUP_CHANGE_AVATAR] = { requiresAuth: true, initOnHash: false };
config[POPUP_FEATURE_FEEDBACK] = { requiresAuth: true, initOnHash: false };
config[POPUP_MODEL_TIP] = { requiresAuth: true, initOnHash: false };
config[POPUP_MODEL_TIP_SUCCESS] = { requiresAuth: true, initOnHash: false };
config[POPUP_MODEL_TIP_OFFER] = { requiresAuth: true, initOnHash: false };
config[POPUP_FEATURE_INTRODUCE] = { requiresAuth: true, initOnHash: false };
config[POPUP_DISCOUNT] = { requiresAuth: true, initOnHash: false };
config[POPUP_LAW_LIMITATION] = { requiresAuth: true, initOnHash: false };
config[POPUP_CAMERA_FEEDBACK] = { requiresAuth: true, initOnHash: false };
config[POPUP_MANUAL_CANCELLATION] = { requiresAuth: true, initOnHash: false };

export default config;
